import { IconSVG } from '../types';

export const Sound = ({ size, style }: IconSVG) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      style={style}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#2F2F2F"
        d="M19 11.975a6.86 6.86 0 0 0-1.1-3.787 6.8 6.8 0 0 0-2.95-2.563 1.1 1.1 0 0 1-.55-.537.95.95 0 0 1-.05-.738q.15-.4.537-.575a.93.93 0 0 1 .788 0 8.8 8.8 0 0 1 3.875 3.288Q21 9.275 21 11.974t-1.45 4.913a8.8 8.8 0 0 1-3.875 3.287.93.93 0 0 1-.788 0 .99.99 0 0 1-.537-.575.95.95 0 0 1 .05-.738q.175-.361.55-.537a6.8 6.8 0 0 0 2.95-2.562 6.86 6.86 0 0 0 1.1-3.788M7 15H4a.97.97 0 0 1-.712-.287A.97.97 0 0 1 3 14v-4q0-.424.288-.713A.97.97 0 0 1 4 9h3l3.3-3.3q.476-.475 1.087-.213.613.263.613.938v11.15q0 .674-.613.938-.612.262-1.087-.213zm9.5-3q0 1.05-.475 1.988a4.46 4.46 0 0 1-1.25 1.537.49.49 0 0 1-.513.012A.46.46 0 0 1 14 15.1V8.85q0-.3.262-.437a.49.49 0 0 1 .513.012A4.7 4.7 0 0 1 16.025 10q.475.95.475 2M10 8.85 7.85 11H5v2h2.85L10 15.15z"
      ></path>
    </svg>
  );
};
